import { render, staticRenderFns } from "./SubjectGroupListAction.vue?vue&type=template&id=f1a57b68"
import script from "./SubjectGroupListAction.vue?vue&type=script&lang=js"
export * from "./SubjectGroupListAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports